export const CARD_BG = 'https://static.fuxi.netease.com/yaotai/portal/20220622/l4p00geb_car.png';
export const CARD_TEXT = [
  '网易瑶台为客户提供沉浸式的车展体验，提供炫丽视觉效果的同时，高精度复刻汽车及展厅；通过 3D 场景重建，将展厅、展台、展品完美复制进虚拟世界。',
  '结合人物智能捏脸、ACE 引擎、RTC 通讯、多端访问等前沿技术，提供线上询价、名片交换、特色讲解等车展专属功能。给予参会者沉浸式看展体验，助力主办方构建专属元宇宙场景、提升数字化能力。',
];

export const DEMANDS = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220721/l5uffkw7_264134.png',
    title: '高效组织',
    text: '提高主办方组织效率，一键配置车展时间和日程安排，协助嘉宾沟通等工作。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5ypay_icon3.png',
    title: '多维度产品展示',
    text: '依托 AI 技术快速构建 3D 展馆、展台、车模展品等，超越文字、图片和视频，提供最接近真实的多维度产品展示。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220628/l4xqtu3t_icon.png',
    title: '创新行业交流平台',
    text: '通过音视频畅聊、私信、自由发言、交换名片等多种在线互动方式，满足行业人员各类社交需求，提高沟通效率。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4c5muwx_icon1.png',
    title: '沉浸式参展体验',
    text: '根据主办方不同活动需求，定制个性化主会场、展览区、产品体验专区等各类场景，增加活动创新体验，让广大汽车爱好者身临其境。',
  },
];

export const FEATURES = [
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220907/l7r5842t_285732.png',
    title: '便捷性的复杂过程管理',
    desc: [
      '后台管理系统支持快捷创建活动信息，自由设置活动时间和日常',
      '丰富多样化的场地：设置场地、展台、展区、展板等',
      '支持自由添加和表格导入等方式设置参加活动的人员信息，可邀约报名或发出门票',
      '协助主办方进行彩排和嘉宾使用讲解等环节',
    ],
  },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hdzpas_348116.png',
    title: '沉浸式的社交感官体验',
    desc: [
      'AI 智能捏脸，打造用户及嘉宾真实形象；表情动作实时同步到虚拟角色，提供丰富感官体验。',
      '在线畅聊、在线询价、视频交流、名片交换、在线客服、沉浸式洽谈、抽奖、弹幕互动等功能应有尽有，助力主办方提升数字化收入。',
    ],
  },
  {
    rightText: true,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1l_920376.png',
    title: '多样化的沉浸式场地',
    desc: [
      '高精度复刻线下活动的多种展示方式，展馆、展厅、展台、展品等，满足车展的多种场地需求',
      '更多创意场景随心定制，古风、沙漠、火星等，用虚拟世界的情景来实现天马行空的创意',
    ],
  },
  // {
  //   rightText: false,
  //   image: 'https://static.fuxi.netease.com/yaotai/portal/20220831/l7hcjo1j_920375.png',
  //   title: '统计车展多项数据',
  //   desc: [
  //     '签到、互动等数据统计，实时监控车展效果',
  //     '展后满意度数据、展板点赞次数、观看人数统计、抽奖结果统计等多维度统计报表，精准看到营销价值',
  //   ],
  // },
  {
    rightText: false,
    image: 'https://static.fuxi.netease.com/yaotai/portal/20220901/l7igzaul_834413.png',
    title: '高质量的业务价值提升',
    desc: ['为展商、赞助商提供多方位品牌内容展示', '整合多渠道传播资源提升活动宣传效果'],
  },
];

export const ADVANTAGES = [
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd7_icon3.png',
    title: '一站式服务',
    text: '瑶台一站式全流程技术服务，覆盖展览前、中、后期的各环节的多样性需求，助力主办方提升会议组织与运营效率。',
  },
  // {
  //   icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd6_icon2.png',
  //   title: '上市企业品牌背书',
  //   text: '网易是纳斯达克及香港上市企业，作为中国领先的互联网技术公司，在市场上具有较强的影响力，并获得了广泛用户群体的信任。瑶台是整合网易集团优势资源和能力，打造的服务活动市场的新平台。',
  // },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd5_icon1.png',
    title: '强有力的技术支持',
    text: '依托于网易在 3D 游戏引擎、AI、云计算等领域的多年积累，强大的技术实力保障平台安全稳定。',
  },
  {
    icon: 'https://static.fuxi.netease.com/yaotai/portal/20220613/l4cephd8_icon4.png',
    title: '个性化定制',
    text: '主办方可以量身定制虚拟活动场地、虚拟角色形象、虚拟交互和会务组织功能，满足多样化活动需求。',
  },
];
